<template>
    <rkm-list
        :fields="fields"
        :repository="repositories.paciente"
        search-by="cadastroCidadao.nome"
        item-cursor="default"
    >
        <template v-slot="{ item }">
            <rkm-row class="flex-nowrap">
                <rkm-col class="flex-grow-0 text-center my-auto">
                    <h4>{{ item.prontuario }}</h4>
                </rkm-col>

                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col>
                            <h4>
                                {{ item.nome }}

                                <template v-if="item.nomeSocial">
                                    <template v-if="item.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                                        <strong>({{ item.nomeSocial }})</strong>
                                    </template>
                                </template>
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row class="justify-content-between">
                        <rkm-col cols="auto">
                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        <strong>Nome da mãe</strong>
                                    </span>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        {{ item.nomeMae || '-' }}
                                    </span>
                                </rkm-col>
                            </rkm-row>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        <strong>Município de residência</strong>
                                    </span>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        <template v-if="item.municipioNome">
                                            {{ item.municipioNome }}
                                            -
                                            {{ item.uf }}
                                        </template>

                                        <template v-else>
                                            -
                                        </template>
                                    </span>
                                </rkm-col>
                            </rkm-row>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row class="justify-content-between">
                        <rkm-col cols="auto">
                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        <strong>Data de nascimento</strong>
                                    </span>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        <template v-if="item.dataNascimento">
                                            {{ item.dataNascimento | formatDate }}
                                        </template>

                                        <template v-else>
                                            -
                                        </template>
                                    </span>
                                </rkm-col>
                            </rkm-row>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        <strong>CNS</strong>
                                    </span>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        <template v-if="item.cns">
                                            {{ item.cns | formatCns }}
                                        </template>

                                        <template v-else>
                                            -
                                        </template>
                                    </span>
                                </rkm-col>
                            </rkm-row>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        <strong>CPF</strong>
                                    </span>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        <template v-if="item.cpf">
                                            {{ item.cpf | formatCpf }}
                                        </template>

                                        <template v-else>
                                            -
                                        </template>
                                    </span>
                                </rkm-col>
                            </rkm-row>
                        </rkm-col>

                        <rkm-col cols="auto">
                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        <strong>RG</strong>
                                    </span>
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        {{ item.rg || '-' }}
                                    </span>
                                </rkm-col>
                            </rkm-row>
                        </rkm-col>

                        <rkm-col cols="auto" v-if="item.obitoEm">
                            <rkm-row>
                                <rkm-col>
                                    <span>
                                        <strong>Óbito</strong>
                                    </span>
                                </rkm-col>
                            </rkm-row>

                            <template>
                                {{ item.obitoEm | formatDate }}
                            </template>
                        </rkm-col>

                        <rkm-col class="d-flex flex-grow-0">
                            <slot
                                name="actions"
                                v-bind:item="item"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </template>
    </rkm-list>
</template>

<script>
// Mixins.
import { data, repository, error } from '@/mixins'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Filters.
import formats from '@/filters/formats'

export default {
    created() {

        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente')
        }
    },
    data: () => ({
        fields: [
            {
                key: 'cadastroPaciente.prontuario',
                label: 'PRONTUÁRIO',
                sortable: true,
                searchable: true
            },
            {
                key: 'cadastroCidadao.nome',
                label: 'NOME',
                sortable: true,
                searchable: true
            },
            {
                key: 'cadastroCidadao.nome_social',
                label: 'NOME SOCIAL',
                sortable: true,
                searchable: true
            },
            {
                key: 'cadastroCidadao.nome_mae',
                label: 'NOME DA MÃE',
                sortable: true,
                searchable: true
            },
            {
                key: 'cadastroCidadao.data_nascimento',
                label: 'DATA DE NASCIMENTO',
                sortable: true,
                searchable: true
            },
            {
                key: 'cadastroCidadao.cns',
                label: 'CNS',
                sortable: true,
                searchable: true
            },
            {
                key: 'cadastroCidadao.cpf',
                label: 'CPF',
                sortable: true,
                searchable: true
            },
            {
                key: 'cadastroCarteiraIdentidade.numero',
                label: 'RG',
                sortable: true,
                searchable: true
            },
        ],
        enums: { preferenciaNome },
    }),
    filters: {
        ...formats
    },
    mixins: [ data, repository, error ],
}
</script>